import { loginUser, resetPassword as reset } from "../../lib/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    ICredentials,
    ILocalStorageUserData,
    IPasswordResetParams,
} from "../../types/users";
import { IAPIResponse } from "../../types/api";
import { alertActions } from "../alert/alertSlice";

interface ILoginResponse extends IAPIResponse, ILocalStorageUserData {}
interface IPasswordResetResponse extends IAPIResponse {
    email: string;
}

export const login = createAsyncThunk<
    ILoginResponse,
    ICredentials,
    { rejectValue: string }
>(
    "auth/login",
    async ({ email, password, remember }, { rejectWithValue, dispatch }) => {
        try {
            const response = await loginUser({
                email,
                password,
                remember,
            });

            localStorage.setItem(
                "userData",
                JSON.stringify({
                    token: response.token,
                    user: {
                        ...response.user,
                    },
                }),
            );
            return response;
        } catch (e) {
            const error = e as string;
            dispatch(
                alertActions.error({
                    level: "danger",
                    text: "Login failed. Please try again",
                    title: error,
                }),
            );
            return rejectWithValue(error);
        }
    },
);

export const resetPassword = createAsyncThunk<
    IPasswordResetResponse,
    IPasswordResetParams,
    { rejectValue: string }
>(
    "auth/resetPassword",
    async (
        { userId, password, confirmPassword },
        { rejectWithValue, dispatch },
    ) => {
        try {
            const response = await reset({
                userId,
                password,
                confirmPassword,
            });

            return response;
        } catch (e) {
            const error = e as string;

            // dispatch(
            //     alertActions.error({
            //         level: "danger",
            //         text: "Password reset failed. Please try again",
            //         title: error,
            //     }),
            // );
            return rejectWithValue(error);
        }
    },
);
